const routes = {
  activities: {
    root: '/activities',
  },
  agenda: {
    root: '/agenda',
  },
  clients: {
    root: '/clients',
  },
  end: {
    root: '/end',
  },
  help: {
    root: '/help',
  },
  home: {
    root: '/',
  },
  login: {
    root: '/login',
  },
  messaging: {
    root: '/messaging',
  },
  parameters: {
    root: '/parameters',
    bank: {
      root: '/parameters/bank',
    },
    bills: {
      root: '/parameters/bills',
    },
    companies: {
      root: '/parameters/companies',
    },
    invite: {
      root: '/parameters/invite',
    },
    location: {
      root: '/parameters/location',
    },
    noteDescription: {
      root: '/parameters/note&description',
    },
    notifications: {
      root: '/parameters/notifications',
    },
    security: {
      root: '/parameters/security',
    },
    socialNetworks: {
      root: '/parameters/social-networks',
    },
    team: {
      root: '/parameters/team',
    },
  },
  socialNetworks: {
    root: '/social-networks',
  },
  passwordReset: {
    root: '/password-reset',
  },
  register: {
    root: '/register',
    activities: {
      root: '/register/activities',
    },
    agenda: {
      root: '/register/agenda',
    },
    bank: {
      root: '/register/bank',
    },
    company: {
      root: '/register/company',
    },
    config: {
      root: '/register/config',
    },
    contract: {
      root: '/register/contract',
    },
    description: {
      root: '/register/description',
    },
    end: {
      root: '/register/end',
    },
    identity: {
      root: '/register/identity',
    },
    insurance: {
      root: '/register/insurance',
    },
    kbis: {
      root: '/register/kbis',
    },
    place: {
      root: '/register/place',
    },
    team: {
      root: '/register/team',
    },
  },
  root: '/',
  signup: {
    root: '/signup',
  },
};

export default routes;
